export { default } from './InputBase';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/InputBase/index.js
// module id = 53
// module chunks = 0